import { makeStyles } from '@rbx/ui';

const useNotificationStyles = makeStyles()(theme => ({
  cardRadius: {
    borderRadius: 8
  },

  container: {
    backgroundColor: theme.palette.surface[400],
    padding: '8px 12px 8px 8px',
    flexWrap: 'nowrap',
    gap: 4,
    minHeight: 52,
    alignItems: 'center'
  },

  containerMultiLine: {
    alignItems: 'flex-start'
  },

  readIconContainer: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 5
  },

  readIcon: {
    borderRadius: '100%'
  },

  notificationText: {
    overflow: 'hidden'
  },

  truncatedText: {
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    wordBreak: 'break-word'
  },

  disabledDot: {
    backgroundColor: theme.palette.states.disabled
  },

  thumbnailContainer: {
    width: 24,
    height: 24
  },

  rightSection: {
    gap: 2,
    flexWrap: 'nowrap',
    alignItems: 'center'
  },

  badgeContainer: {
    width: 16,
    height: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  timeText: {
    whiteSpace: 'nowrap',
    fontSize: 14,
    lineHeight: 1.4
  },

  menuButton: {
    padding: 2,
    width: 20,
    height: 20,
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
}));

export default useNotificationStyles;
